// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
   apiKey: "AIzaSyAu_IW7IS69ykDLr8OKXUJD-olYIUmQjAI",
   authDomain: "nightlifesi.firebaseapp.com",
   projectId: "nightlifesi",
   storageBucket: "nightlifesi.appspot.com",
   messagingSenderId: "67542323617",
   appId: "1:67542323617:web:5972d98f1ddbc8a0133be0",
   measurementId: "G-TX8PJ50B9W"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const storage = getStorage(app)
export const auth = getAuth(app);
export const db = getFirestore(app);